import React from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ModalBody, Row } from 'reactstrap'

export function BranchManagers (props) {
  return (
    <FormLoader {...props} render={({ targetId, branchId }) =>
      <ValidationBoundary>
        <BasicHeader title='Institutions.BranchManager' {...props} />
        <ModalBody>
          <Row>
            <div className='col-12'>
              <FormRow label='Individuals.SelectIndividual' name='person' value={targetId} inputType='dropdown' dataSource={req => context.api.individualService.getPersonForBranch(branchId || 0, req)} required />
              <FormRow label='Common.ValidFrom' name='validFrom' inputType='date' required />
              <FormRow label='Common.ValidTo' name='validTo' inputType='date' />
            </div>
          </Row>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  modalProps: {
    size: 'lg'
  },
  component: BranchManagers
}



// WEBPACK FOOTER //
// ./src/dialogs/branchManagers.js